// extracted by mini-css-extract-plugin
module.exports = {"container":"InteractionReports_container__Y2qZE","title":"InteractionReports_title__2n7y6","stats":"InteractionReports_stats__3oap2"};